import { useEffect, useState, lazy, Suspense } from 'react';
import Papa from "papaparse";
// import { usePapaParse } from 'react-papaparse'; OLD CSV READING TECHNIQUE

//import GLOBAL STYLING
import '../assets/scss/_global_variables_and_styles.scss';

//import the pages 
//[to keep the bundle size smaller, you have to ensure you don't import the same content unnecessarily - hence both langs in same component now!]
//(also using lazy loading to help with package size)
// const California = lazy(() => import("../pages/California/California"));
const CaliforniaRedirect = lazy(() => import("../pages/CaliforniaRedirect/CaliforniaRedirect"));
// const Florida = lazy(() => import("../pages/Florida/Florida"));
const FloridaRedirect = lazy(() => import("../pages/FloridaRedirect/FloridaRedirect"));
// const NewDestinations = lazy(() => import("../pages/NewDestinations/NewDestinations"));
const NewDestinationsRedirect = lazy(() => import("../pages/NewDestinationsRedirect/NewDestinationsRedirect"));
// const Ottawa = lazy(() => import("../pages/Ottawa/Ottawa"));
const OttawaRedirect = lazy(() => import("../pages/OttawaRedirect/OttawaRedirect"));

// *** RETIRED PAGES ***
// const FloridaPasses = lazy(() => import("../pages/FloridaPasses/FloridaPasses"));
// import Home from "../pages/Home/Home";


const Content = (props) => {

    const {lang, dest} = props; // establish what the content should be from the props

    //setup table data state
    const [tableData, setTableData] = useState([]);

    //useEffect (with dependancies!) to set state with CSV data
    useEffect(() => {

        // ACCESS DATA FROM LOCAL (USING PAPAPARSE TO FETCH AND CONVERT THE DATA):
        // (SEE HOW TO EXTRACT DATA DIRECTLY FROM GOOGLE SHEETS AT BOTTOM!)
        // parseCSV function
        const parseCSV = (url) => {
            Papa.parse(`${process.env.PUBLIC_URL}/${url}?_=${(new Date()).getTime()}`, {
                download: true,
                header: true, //setting header to 'true' means array provided contains objects that use row header as key!
                complete: results => {
                    setTableData(results.data); //save csv values as tableData state (remember all data is saved as a STRING - any line breaks in the CSV will have to be converted from '<br/>', in this example, to '\r\n')
                    console.log(`lang: ${lang} | dest: ${dest}`);
                    console.log(`Download URL: ${url}`);
                    console.log('CSV download complete');
                },
                error: (error) => {
                    console.log(error);
                }
            });
        }
        
        let url = ''; //initiate 'url' for the papaparse func below (defined by if else) 

        if(dest && lang){ //check lang and dest are defined (and are an actual destination)
            if(dest === 'california' ||  dest === 'florida' || dest === 'ottawa' || dest === 'new_destinations' ){

                url = `data/${dest}_${lang}.csv`; //update the file source from props
                parseCSV(url);

            } else {

                url = `data/new_destinations_${lang}.csv`; //update the file source from props
                parseCSV(url);

            }

        } else if (lang && !dest) { //homepage content (lang defined, but no destination)

            // 'lang' is **ALWAYS** defined (by parent state), so this is the main fall-back
            // (no lang is likely an error)

            url = `data/new_destinations_${lang}.csv`; //update the file source from props
            parseCSV(url);

        } else { //homepage content (no lang or dest defined)
            // AS LANG IS **ALWAYS** SET BY THE PARENT STATE (if blank, set to 'en'), 
            // WE DON'T WANT TO RUN PAPAPARSE UNTIL PARENT STATE IS SET

            console.log('dest and lang not set');
            
        }
        
    }, [lang, dest]); //have to define which dependancies will trigger useEffect

    return(
        <>
            {dest === 'california' && (
                // Added <>...</> to show it's loading, but can place a loading Component in there, if you want...
                <Suspense fallback={<>...</>}>
                    <CaliforniaRedirect lang={lang} tableData={tableData} />
                </Suspense>
            )}


            {dest === 'florida' && (
                <Suspense fallback={<>...</>}>
                    <FloridaRedirect lang={lang} tableData={tableData} />
                </Suspense>
            )}


            {dest === 'ottawa' && (
                <Suspense fallback={<>...</>}>
                    <OttawaRedirect lang={lang} />
                </Suspense>
            )}


            {dest === 'new_destinations' && (
                <Suspense fallback={<>...</>}>
                    <NewDestinationsRedirect lang={lang} tableData={tableData} />
                </Suspense>
            )}


            {dest && dest !== 'california' && dest !== 'florida' && dest !== 'ottawa' && dest !== 'new_destinations'  && (
                <Suspense fallback={<>...</>}>
                    <NewDestinationsRedirect lang={lang} tableData={tableData} />
                </Suspense>
            )} 
            

            {!dest && (
                <Suspense fallback={<>...</>}>
                    <NewDestinationsRedirect lang={lang} tableData={tableData} />
                </Suspense>
            )}
        </>
    );
}

export default Content;


// OLD PAPAPARSE FUNCTION (react-papaparse)
// const { readRemoteFile } = usePapaParse();

// readRemoteFile(url + "?_=" + (new Date).getTime(), { //adding the time to prevent caching (causing faults)
//     header: true, //setting header to 'true' means array provided contains objects that use row header as key!
//     complete: (results) => {
//         setTableData(results.data); //save csv values as tableData state (remember all data is saved as a STRING - any line breaks will have to be converted from '<br/>', in this example, to '\r\n')
//         console.log(url + "?_=" + (new Date).getTime());
//     },
//     error: (error) => {
//         console.log(error);
//     }
// });



// ==========================================================================================



// ACCESS DATA FROM GOOGLE SHEET:
    // https://stackoverflow.com/questions/69045745/how-do-i-fetch-google-spreadsheet-data-from-javascript-in-sheets-v4-api-as-json
    // Using GVIZ: https://ai2.metricrat.co.uk/guides/use-gviz-to-get-and-query-google-sheet-data
    
    // let url = 'https://docs.google.com/spreadsheets/d/1_U-GU8P3_KVG8Zb9uB6Fw8QkzEm3lLgET3ZM5DT2KyQ/gviz/tq?tqx=out:json&tq&gid=0';
    // fetch(url)
    // .then((response) => {
    //     return response.text(); //keep as 'text' (not '.json()'), since the JSON responce is wrapped in Google query 
    // })
    // .then((data) => {
    //     data = data.replace('/*O_o*/', '').replace('google.visualization.Query.setResponse(','').slice(0, -2); //remove the Google query wrapper
    //     data = JSON.parse(data); //convert the string (looks like JSON) to JSON data
    //     console.log(data);
    // })
    // .catch(function() {
    //     console.log('Failure');
    // });

    // Local Data (NOT SHEETS) - parse without package:
    // fetch(url)
    // .then((response) => {
    //     console.log(response);
    //     return response.text(); //keep as 'text' (not '.json()'), since the JSON responce is wrapped in Google query 
    // })
    // .then((data) => {
    //     data = readString(data);
    //     console.log(data);
    // })

    // <div className="destination_launch_table_wrapper">
    //     <div className="destination_launch_table">
    //         <div className="destination_launch_row destination_launch_row_2_columns destination_launch_header">
    //             <div className="destination_launch_cell destination_launch_cell_blue">Destination</div>
    //             <div className="destination_launch_cell destination_launch_cell_blue">Begins Flying</div>
    //         </div>

    //         <div className="destination_launch_row destination_launch_row_2_columns" announceDate="20221208">
    //             <div className="destination_launch_cell">Toronto Pearson</div>
    //             <div className="destination_launch_cell destination_launch_cell_date" launchDate="20230201">February 1</div>
    //         </div>

    //         <div className="destination_launch_row destination_launch_row_2_columns" announceDate="20221208">
    //             <div className="destination_launch_cell">Vancouver</div>
    //             <div className="destination_launch_cell destination_launch_cell_date" launchDate="20230207">February 7</div>
    //         </div>
    
    //         <div className="destination_launch_row destination_launch_row_2_columns" announceDate="20221208">
    //             <div className="destination_launch_cell">Edmonton</div>
    //             <div className="destination_launch_cell destination_launch_cell_date" launchDate="20230214">February 14</div>
    //         </div>

    //         <div className="destination_launch_row destination_launch_row_2_columns" announceDate="20221208">
    //             <div className="destination_launch_cell">Calgary</div>
    //             <div className="destination_launch_cell destination_launch_cell_date" launchDate="20230222">February 22</div>
    //         </div>

    //     </div>
    // </div>